module.exports = __webpack_public_path__ + "img/yesil_teknoloji.981faa9f.webp";